<template>
    <div>
        <v-gobackbutton>返回</v-gobackbutton>
        <FormTitle title="短信详情"/>
        <a-form @submit="handleSubmit" :form="form">
            <a-form-item
                label="手机号"
                :labelCol="formItemLayout.labelCol"
                :wrapperCol="formItemLayout.wrapperCol"
            >
                <a-input
                    
                    style="width:500px"
                    v-decorator="[
                        'telephone',
                        {
                            initialValue: record.telephone,
                        }
                    ]"
                />
            </a-form-item>

            <a-form-item label="商户号" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    
                    style="width:500px"
                    v-decorator="[
                        'shopcode',
                        {
                            initialValue: record.shopcode,
                        }
                    ]"
                />
            </a-form-item>
            <a-form-item label="短信类型" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    
                    style="width:500px"
                    v-decorator="[
                        'smstype',
                        {
                            initialValue: record.smstype,
                        }
                    ]"
                />
            </a-form-item>
            
            <a-form-item label="短信模板编码" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    
                    style="width:500px"
                    v-decorator="[
                        'templatecode',
                        {
                            initialValue: record.templatecode,
                        }
                    ]"
                />
            </a-form-item>
            <a-form-item label="短信模板名称" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    
                    style="width:500px"
                    v-decorator="[
                        'templatename',
                        {
                            initialValue: record.templatename,
                        }
                    ]"
                />
            </a-form-item>
            <a-form-item label="模板类型" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    
                    style="width:500px"
                    v-decorator="[
                        'templatetype',
                        {
                            initialValue: record.templatetype,
                        }
                    ]"
                />
            </a-form-item>
             <a-form-item label="短信内容" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-textarea
                    
                    style="width:500px"
                    v-decorator="[
                        'recipientname',
                        {
                            initialValue: record.message,
                        }
                    ]"
                 />
            </a-form-item>
            <a-form-item label="接收人名" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    
                    style="width:500px"
                    v-decorator="[
                        'recipientname',
                        {
                            initialValue: record.recipientname,
                        }
                    ]"
                />
           </a-form-item>
           <a-form-item label="短信发送状态" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    
                    style="width:500px"
                    v-decorator="[
                        'statusname',
                        {
                            initialValue: record.statusname,
                        }
                    ]"
                />
            </a-form-item>

            <a-form-item label="错误码" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    
                    style="width:500px"
                    v-decorator="[
                        'errcode',
                        {
                            initialValue: record.errcode,
                        }
                    ]"
                />
            </a-form-item>
            <a-form-item label="英文错误信息" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    
                    style="width:500px"
                    v-decorator="[
                        'errmsgen',
                        {
                            initialValue: record.errmsgen,
                        }
                    ]"
                />
            </a-form-item>
            <a-form-item label="中文错误信息" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    
                    style="width:500px"
                    v-decorator="[
                        'errmsgcn',
                        {
                            initialValue: record.errmsgcn,
                        }
                    ]"
                />
            </a-form-item>
            <a-form-item label="ali短信服务签名" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    
                    style="width:500px"
                    v-decorator="[
                        'signname',
                        {
                            initialValue: record.signname,
                        }
                    ]"
                />
            </a-form-item>
            <a-form-item label="签名对应编码" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    
                    style="width:500px"
                    v-decorator="[
                        'signnamecode',
                        {
                            initialValue: record.signnamecode,
                        }
                    ]"
                />
            </a-form-item>
            <a-form-item label="服务商编码" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    
                    style="width:500px"
                    v-decorator="[
                        'servercode',
                        {
                            initialValue: record.servercode,
                        }
                    ]"
                />
            </a-form-item>
            <a-form-item label="发送回执ID" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    
                    style="width:500px"
                    v-decorator="[
                        'biz_id',
                        {
                            initialValue: record.biz_id,
                        }
                    ]"
                />
            </a-form-item>
            <a-form-item label="外部唯一流水号" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    
                    style="width:500px"
                    v-decorator="[
                        'out_id',
                        {
                            initialValue: record.out_id,
                        }
                    ]"
                />
            </a-form-item>
            <a-form-item label="发送时间" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    
                    style="width:500px"
                    v-decorator="[
                        'createtime',
                        {
                            initialValue: record.createtime,
                        }
                    ]"
                />
            </a-form-item>

            <a-form-model-item   style="text-align: center">
                <a-button type="primary" @click="refresh">
                    刷新状态
                </a-button>
                <a-button type="primary" style="margin-left: 20px;" >
                    <a-popconfirm title="确认重新发送?" @confirm="() => rsend(record)">
                      <a>重新发送</a>
                </a-popconfirm>
                </a-button>
               

                <a-button type="primary" style="margin-left: 20px;" @click="handleCancel">
                    返回
                </a-button>    
            </a-form-model-item>
        </a-form>
    </div>
</template>

<script>
import FormTitle from "../../components/FormTitle.vue";
import { mapState } from "vuex";

const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 18 }
};

export default {
    data() {
        return {
            formItemLayout,
            formLayout: "horizontal",
            form: this.$form.createForm(this),
            disabled:  true 
        };
    },
    computed: {
        ...mapState("smsmanager", {
            record: function(state) {
                //这里需要注意 this 指向问题, 如果用箭头函数, 会有this作用域的问题
                return   state.record;
            }
        })
    },
    methods: {
        //域名信息表单提交
        handleSubmit(e) {
            e.preventDefault();
        },

        // 刷新短息发送状态
        refresh() {
            this.confirmLoading = true;
            this.record.id = this.record.id;
            let c_params = {};
            c_params.queryDate=this.record.createtime;
            c_params.telephone=this.record.telephone;
            this.$store
                .dispatch({
                    type: "smsmanager/updateSmsStatus",
                    params: c_params
                })
                .then((response) => {
                    if(response.data.success == '1'){
                        console.log(response)
                        this.confirmLoading = false;
                        this.message.success("更新成功！")
                        const { query } = this.$route;

                        this.$store.dispatch({
                            type: "smsmanager/details",
                            params: query,
                            showMsg: false
                        });
                    }
                });
            
        },

        // 短信重发
        rsend() {
            this.confirmLoading = true;
            this.record.id = this.record.id;
            let c_params = {};
            c_params.id=this.record.id;
            this.$store
                .dispatch({
                    type: "smsmanager/resendmsg",
                    params: c_params
                })
                .then((response) => {
                    if(response.data.success == '1'){
                        console.log(response)
                        this.message.success("重发成功！")
                        this.handleCancel();
                        this.confirmLoading = false;
                    }
                });
            
        },
        handleCancel() {
            this.$router.back(-1);
        },

    },
    mounted() {

        const { query } = this.$route;

        this.$store.dispatch({
            type: "smsmanager/details",
            params: query,
            showMsg: false
        });
    },
    components: {
        FormTitle
    }
};
</script>

<style scoped>
</style>